import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png"; 

const Footer = () => {
  const quickLinks = [
    { name: "Home", path: "/" },
    { name: "Find Inverter", path: "/inverter" },
  ];

  return (
    <footer
     style={{
        background: "rgba(9, 135, 66, 0.79)", 
        color: "#e5e7eb",
        padding: "3rem 1rem 2rem 1rem",
        fontFamily: "'Noto Sans', sans-serif",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: "2rem",
        }}
      >
       
        <div>
          <Link
            to="/"
            style={{
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
              marginBottom: "1rem",
            }}
          >
            <img
              src={logo}
              alt="WattWise Logo"
              style={{
                height: "38px",
                marginRight: "0.75rem",
                borderRadius: "8px",
                background: "#fff",
                padding: "2px",
                boxShadow: "0 2px 8px rgba(30,58,138,0.08)",
              }}
            />
            <h3
              style={{
                fontSize: "1.5rem",
                color: "#ffffffff", 
                margin: 0,
                fontWeight: 700,
                letterSpacing: "0.5px",
              }}
            >
              WattWise
            </h3>
          </Link>
          <p
            style={{
              fontSize: "0.95rem",
              lineHeight: 1.6,
              color: "#ffffffff",
            }}
          >
            Your smart partner for inverters. We provide expert advice, detailed
            comparisons, and reliable recommendations to help you choose the
            perfect power solution for your home.
          </p>
        </div>

     
        <div>
          <h4
            style={{
              fontSize: "1.2rem",
              marginBottom: "1rem",
              color: "#f7f7f7ff", 
            }}
          >
            Quick Links
          </h4>
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {quickLinks.map((link) => (
              <li key={link.name} style={{ marginBottom: "0.5rem" }}>
                <Link
                  to={link.path}
                  style={{
                    color: "#ffffffff",
                    textDecoration: "none",
                    fontSize: "0.95rem",
                    transition: "all 0.2s",
                  }}
                  onMouseEnter={(e) => (e.target.style.color = "#1E3A8A")}
                  onMouseLeave={(e) => (e.target.style.color = "#d1d5db")}
                >
                  → {link.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div
        style={{
          borderTop: "2px solid #ffffffff", 
          marginTop: "2rem",
          paddingTop: "1rem",
          textAlign: "center",
          fontSize: "0.85rem",
          color: "#ffffffff",
        }}
      >
        © 2025 WattWise. All rights reserved. |{" "}
        <Link
          to="https://kverty.com/privacy"
          style={{
            color: "#000000ff",
            textDecoration: "underline",
          }}
        >
          Privacy Policy
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
